var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 134,
    viewBox: "0 0 140 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .logo_cls-1{fill:url(#logo_radial-gradient);}\n      .logo_cls-2{fill-rule:evenodd;}\n      .logo_cls-3{fill:url(#logo_radial-gradient-2);}\n      .logo_cls-4{fill:url(#logo_radial-gradient-3);}\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_radial-gradient",
    cx: 67.28,
    cy: 347.01,
    r: 1,
    gradientTransform: "matrix(0, 64.68, 64.68, 0, -22376.23, -4286.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f7cfda"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_radial-gradient-2",
    cx: 72.26,
    cy: 348.72,
    r: 1,
    gradientTransform: "matrix(-10.73, 24.33, 34.45, 15.2, -11123.07, -6949.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f7cfda"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_radial-gradient-3",
    cx: 70.87,
    cy: 344.4,
    r: 1,
    gradientTransform: "matrix(8.76, 24.37, 34.5, -12.4, -12476.84, 2653.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f7cfda"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-1",
    d: "M132.46,65.06A64.68,64.68,0,1,1,67.78.38,64.67,64.67,0,0,1,132.46,65.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-2",
    d: "M49.61,45.6A6.57,6.57,0,1,0,36.91,49l-2.57.69a9.23,9.23,0,0,1,17.84-4.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-2",
    d: "M90.73,38.1a6.58,6.58,0,0,0-12.91,2.51l-2.6.51A9.23,9.23,0,1,1,93.34,37.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-2",
    d: "M44.57,73.72c7.27.45,17.07-.43,27.64-2.77S92,65.27,98.44,61.8a29.17,29.17,0,0,0,7.16-5.09c1.57-1.65,1.94-2.9,1.75-3.77l2.6-.58c.48,2.19-.66,4.32-2.41,6.18a32,32,0,0,1-7.83,5.6c-6.68,3.62-16.18,7-26.92,9.41S52,76.84,44.41,76.38A32.1,32.1,0,0,1,35,74.6c-2.38-.94-4.31-2.4-4.79-4.58l2.59-.57c.19.87,1.06,1.84,3.18,2.68A29,29,0,0,0,44.57,73.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-2",
    d: "M24.33,87.68a21.68,21.68,0,0,0,0,43.35h25.8a3.27,3.27,0,0,0,0-6.54H35.41v-2.66H59.33a3.27,3.27,0,1,0,0-6.54H39.09v-2.66H63a3.28,3.28,0,0,0,0-6.55H39.09v-2.65H58.41a3.28,3.28,0,0,0,0-6.55H26.67V94.23H39.09a3.28,3.28,0,0,0,0-6.55V85A5.93,5.93,0,0,1,44,94.23H58.41a5.93,5.93,0,0,1,4.94,9.21,5.93,5.93,0,0,1,.84,11.73,5.92,5.92,0,0,1-4.86,9.32H55.07a5.81,5.81,0,0,1,1,3.27,5.94,5.94,0,0,1-5.93,5.93H24.33a24.34,24.34,0,0,1,0-48.67H39.09v2.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-2",
    d: "M114.6,87.68a21.68,21.68,0,0,1,0,43.35H88.8a3.27,3.27,0,0,1,0-6.54h14.73v-2.66H79.6a3.27,3.27,0,0,1,0-6.54H99.85v-2.66H75.92a3.28,3.28,0,0,1,0-6.55H99.85v-2.65H80.52a3.28,3.28,0,0,1,0-6.55h31.75V94.23H99.85a3.28,3.28,0,1,1,0-6.55V85a5.94,5.94,0,0,0-4.95,9.21H80.52a5.93,5.93,0,0,0-4.94,9.21,5.93,5.93,0,0,0-.84,11.73,5.92,5.92,0,0,0,4.86,9.32h4.26a5.93,5.93,0,0,0,4.94,9.2h25.8a24.34,24.34,0,0,0,0-48.67H99.85v2.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-3",
    d: "M114.6,87.68a21.68,21.68,0,0,1,0,43.35H88.8a3.27,3.27,0,0,1,0-6.54h14.73v-2.66H79.6a3.27,3.27,0,0,1,0-6.54H99.85v-2.66H75.92a3.28,3.28,0,0,1,0-6.55H99.85v-2.65H80.52a3.28,3.28,0,0,1,0-6.55h31.75V94.23H99.85a3.28,3.28,0,1,1,0-6.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "logo_cls-4",
    d: "M24.3,87.72a21.67,21.67,0,0,0,0,43.34H50.09a3.27,3.27,0,0,0,0-6.54H35.37v-2.66H59.29a3.27,3.27,0,1,0,0-6.54H39.05v-2.66H63a3.27,3.27,0,1,0,0-6.54H39.05v-2.66H58.37a3.27,3.27,0,1,0,0-6.54H26.63V94.26H39.05a3.27,3.27,0,0,0,0-6.54Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0460600728403a09de8c9038a206df3.svg";
export { ForwardRef as ReactComponent };